<template>
  <div class="render-icon" :iconType="iconType" :iconName="iconName" :style="renderStyle">
    <template v-if="iconType == 'el-icon'">
      <el-icon v-if="iconComponentName" :size="size" :color="color">
        <component :is="iconComponentName" />
      </el-icon>
    </template>
    <RenderCustomComponent
      v-else-if="iconType == 'custom'"
      :style="{
        width: size,
        height: size,
        fontSize: size
      }"
      :color="color"
    ></RenderCustomComponent>
    <CustomIconFont v-else-if="iconType == 'iconfont-icon'" :iconName="shortIconName" :size="size" :color="color"></CustomIconFont>
  </div>
</template>
<script setup lang="ts">
import { computed, defineAsyncComponent, getCurrentInstance, ref, watch } from 'vue'
import CustomIconFont from './CustomIconFont.vue'
import { adaptStyle, pxToVwCss } from '@/utils/tools'

const props = withDefaults(
  defineProps<{
    /**
     * @see IconType
     * 'custom-xxx' | 'iconfont-xxx' | 'el-icon-xxx' | ''
     * https://element-plus.org/zh-CN/component/icon.html#icon-collection
     */
    iconName: string
    size?: number | string //文字默认单位px
    color?: string
    style?: any
    boxWidth?: number | string //文字默认单位px
    boxHeight?: number | string //文字默认单位px
    iconResolveFailFill?: string
  }>(),
  {
    size: '0.16rem',
    color: '#333',
    boxWidth: '0.16rem',
    boxHeight: '0.16rem',
    style: {},
    iconResolveFailFill: '#999'
  }
)
const renderStyle = computed(() => {
  let style: { [key: string]: any } = { width: props.boxWidth, height: props.boxHeight, ...props.style }
  return adaptStyle(style)
})
let isCustomIcon = ref(false)
let iconComponentName: any = ''
let RenderCustomComponent = <any>{}

// watch(
//   () => props.iconName,
//   (nd, od) => {
// console.log('watch custom', nd, props)
export type IconType = 'custom' | 'iconfont-icon' | 'el-icon' | ''
let iconType = ref(<IconType>'')
let shortIconName = ref('')

if (props.iconName.startsWith('custom-')) {
  iconType.value = 'custom'
  //Glob 导入 https://cn.vitejs.dev/guide/features.html#glob-import
  const modules = import.meta.glob('./custom/*.vue')
  //自定义组件图标
  RenderCustomComponent = defineAsyncComponent({
    async loader() {
      try {
        shortIconName.value = props.iconName.replace('custom-', '')
        if (shortIconName.value) {
          const url = './custom/' + shortIconName.value + '.vue'
          const component = (await modules[url]()) as any
          // console.info('component-------:', component, iconName)
          return component
        }
        return undefined
      } catch (e) {
        // console.log('组件加载失败：', e)
        isCustomIcon.value = false
        return () => Promise.reject('组件加载失败：')
      }
    }
  })
} else if (props.iconName.startsWith('iconfont-icon')) {
  iconType.value = 'iconfont-icon'
  shortIconName.value = props.iconName.replace('iconfont-', '')
} else if (props.iconName.startsWith('el-icon-')) {
  iconType.value = 'el-icon'
  shortIconName.value = props.iconName.replace('el-icon-', '')
  // //xx-yy => XxYy 首字母大写
  // let icon = props.iconName ? props.iconName.replace(/-/g, '').replace(/(?:^|-)(\w)/g, (_, c) => c.toUpperCase()) : ''
  const currentInstance = getCurrentInstance()
  if (currentInstance) {
    iconComponentName = currentInstance.appContext.components[shortIconName.value]
  }
}
// isCustomIcon.value = props.iconName && props.iconName.startsWith('custom-') ? true : false
// //不是自定义组件图标
// if (!isCustomIcon.value) {
//   //xx-yy => XxYy 首字母大写
//   let icon = props.iconName ? props.iconName.replace(/-/g, '').replace(/(?:^|-)(\w)/g, (_, c) => c.toUpperCase()) : ''
//   if (currentInstance) {
//     iconComponentName = currentInstance.appContext.components[icon]
//     // console.log('currentInstance value', currentInstance, iconComponentName, icon)
//   }
//   //填充默认值
//   if (!iconComponentName) {
//     iconComponentName = props.iconResolveFailFill
//   }
// } else {
//   //自定义组件图标
//   RenderCustomComponent = defineAsyncComponent({
//     async loader() {
//       try {
//         let iconName = props.iconName
//         if (iconName) {
//           const url = './custom/' + iconName.replace('custom-', '') + '.vue'
//           const component = (await modules[url]()) as any
//           // console.info('component-------:', component, iconName)
//           return component
//         }
//         return undefined
//       } catch (e) {
//         // console.log('组件加载失败：', e)
//         isCustomIcon.value = false
//         return () => Promise.reject('组件加载失败：')
//       }
//     }
//   })
// }

// },
//   { immediate: true }
// )
</script>
<style lang="scss" scoped>
.render-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
